import {
  dataWorkshopEntityId,
  DataWorkshopEntityId,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataWorkshopGetRequestDTO {
  private static validation = Validate.compile(
    DataWorkshopGetRequestDTO.validationSchema()
  );

  constructor(readonly data: DataWorkshopGetRequestDTORaw) {
    Validate.assert(DataWorkshopGetRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['id'],
      properties: {
        id: dataWorkshopEntityId,
      },
    };
  }
}

interface DataWorkshopGetRequestDTORaw {
  id: DataWorkshopEntityId;
}
